import React from 'react'
import { Grid, Typography } from '@mui/material'
import { MtLogo } from '../logos'
import { useStyles } from './style'

const Footer = () => {
  const classes = useStyles()

  return (
    <Grid
      item
      container
      gap={2}
      justifyContent='center'
      alignItems='center'
      className={classes.footer}
    >
      <Grid item>
        <MtLogo width='120' height='24' />
      </Grid>
      <Grid item>
        <Typography className={classes.copyrightText}>
          {new Date().getFullYear()} All rights reserved.
        </Typography>
      </Grid>
    </Grid>
  )
}

export default Footer
